import React from "react";

import Coverages from "../../../../components/Habitacional/Coverages";
import TitleIcon from "../../../../components/Habitacional/TitleIcon";
import HeroSection from "../../../../components/Habitacional/HeroSection";
import BannerAlert from "../../../../components/Habitacional/BannerAlert";
import ContentSection from "../../../../components/Habitacional/ContentSection";
import ContactSection from "../../../../components/Habitacional/ContactSection/ContactSection";

import CtaTrakingYourClaimWithCpf from "../../../../components/Habitacional/CtaTrakingYourClaimWithCpf";
import CtaDrawResults from "../../../../components/Habitacional/CtaDrawResult";
import BackNavigationButton from "../../../../components/Habitacional/core/BackNavigationButton/BackNavigationButton";

import { ReactComponent as Alert } from "../../../../assets/images/habitacional/alert-icon.svg";

import BannerMais from "../../../../assets/images/backgrounds/banner-mais-desktop.png";
import BannerMaisMobile from "../../../../assets/images/backgrounds/banner-mais-mobile.png";

import { ReactComponent as Icon } from "../../../../assets/images/habitacional/icon-title-mais.svg";

import GeneralCondition from "../../../../components/Habitacional/GeneralCondition/GeneralCondition";
import AssistanceServicesAccordion from "../../../../components/Habitacional/AssistanceServicesAccordion";
import ContentWithMoreThanOneVideo from "../../../../components/Habitacional/ContentWithMoreThanOneVideo";

const videos = [
  {
    id: 1,
    title: "Coberturas",
    description:
      "Confira o que o seguro cobre (MIP, DFI e DFC) e o que não cobre. ",
    link: "https://www.youtube.com/embed/xX7mVuSukDU?si=gCTbbJbLX9wPTM1k",
  },
  {
    id: 2,
    title: "Quero acionar a cobertura (sinistro)!",
    description:
      "Saiba como dar entrada no pedido de indenização (sinistro) e como acompanhar. ",
    link: "https://www.youtube.com/embed/0t9yB6OJEgE?si=BSspdoqWefqBp-ax",
  },
  {
    id: 3,
    title: "Assistências",
    description:
      "O cano estourou? Conheça os serviços para resolver imprevistos do dia a dia.",
    link: "https://www.youtube.com/embed/-ad0OO99EqE?si=7tnqRQl6jU-aVis6",
  },
];

const MaisPage = () => {
  return (
    <>
      <HeroSection
        backgroundImageDesktop={BannerMais}
        backgroundImageMobile={BannerMaisMobile}
        primarySubtitle="Seguro Habitacional"
        mainTitle="Mais"
      />

      <BannerAlert
        icon={<Alert />}
        mainText={
          <>
            <strong style={{ fontSize: "20px", fontWeight: 600 }}>
              Importante
            </strong>
            : Este seguro não é mais comercializado pela Caixa Seguradora desde
            fevereiro de 2021. Se você contratou o Seguro Habitacional depois de
            14/02/2021 e quer saber mais, por favor, entre em contato
            diretamente com a agência da Caixa onde foi realizado o seu
            financiamento ou acesse o aplicativo Caixa.
          </>
        }
      />

      <ContentSection>
        <BackNavigationButton href="/paravoce/habitacional/" />
        <TitleIcon icon={<Icon />} title="Seguro Habitacional Mais" />
        <Coverages />
      </ContentSection>

      <AssistanceServicesAccordion />

      <ContentWithMoreThanOneVideo slideVideos={videos} />

      <ContactSection />

      <CtaTrakingYourClaimWithCpf />

      <CtaDrawResults />

      <GeneralCondition
        description="Escolha o seguro e baixe as Condições Gerais. "
        documentList={[
          {
            link:
              "https://cdn.caixaseguradora.com.br/AreaAberta/Habitacional/CondicoesGerais/Seguro-Habitacional-Mais.pdf",
            text: "Seguro Habitacional Mais - FGTS",
          },
          {
            link:
              "https://cdn.caixaseguradora.com.br/AreaAberta/Habitacional/CondicoesGerais/Seguro-Habitacional-Mais.pdf",
            text: "Seguro Habitacional Mais - SBPE",
          },
        ]}
      />
    </>
  );
};

export default MaisPage;
